import { Uploader } from "./../plugin-commons/index";
import { FILE_UPLOAD_TYPE } from "./types";
const handleExternalFileChange = (editorCommands, updateService, filePluginService) => ({ data }) => {
  if (data instanceof Array) {
    data.forEach((file, index) => {
      setTimeout(() => {
        const nodeId = editorCommands.insertBlockWithBlankLines(
          FILE_UPLOAD_TYPE,
          {},
          { updateSelection: data.length === index + 1 }
        );
        updateService.updatePluginData(
          { data: file },
          nodeId,
          FILE_UPLOAD_TYPE,
          filePluginService
        );
      });
    });
  } else {
    const nodeId = editorCommands.insertBlockWithBlankLines(FILE_UPLOAD_TYPE, {});
    updateService.updatePluginData({ data }, nodeId, FILE_UPLOAD_TYPE, filePluginService);
  }
};
const handleNativeFileChange = (editorCommands, uploadService, uploader, filePluginService) => (files) => {
  files.forEach((file, index) => {
    setTimeout(() => {
      const nodeId = editorCommands.insertBlockWithBlankLines(
        FILE_UPLOAD_TYPE,
        {},
        { updateSelection: files.length === index + 1 }
      );
      uploadService.uploadFile(
        new File([file], file.name, { type: file.type }),
        nodeId,
        uploader,
        FILE_UPLOAD_TYPE,
        filePluginService
      );
    });
  });
};
const handleFileUpload = ({
  config,
  services,
  filePluginService,
  editorCommands
}) => {
  const { uploadService, updateService } = services;
  if (config.handleFileSelection) {
    config.handleFileSelection(
      handleExternalFileChange(editorCommands, updateService, filePluginService)
    );
  } else {
    const { accept = "*", multi = true, onFileSelected } = config;
    uploadService?.selectFiles(
      accept,
      multi,
      handleNativeFileChange(
        editorCommands,
        uploadService,
        new Uploader(onFileSelected),
        filePluginService
      )
    );
  }
};
export {
  handleFileUpload
};
//# sourceMappingURL=handle-file-upload.js.map
